/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

export const commonProp8: Array<[string, string]> = [
    ["CASUAL_WEAR", "Be\u017en\u00e9"],
    ["OCCASIONAL_WEAR", "Pr\u00edle\u017eitostn\u00e9"],
];
